const DefaultConfig = {
	admobAppId_Android: 'ca-app-pub-2191584882036728~2517650801',
	admobInterstitialAdId_Android: 'ca-app-pub-2191584882036728/9382442054',
	admobRewardedAdId_Android: 'ca-app-pub-2191584882036728/5498488623',
	admobAppOpenAdId_Android: 'ca-app-pub-2191584882036728/3883537516',
	admobAppId_iOS: 'ca-app-pub-2191584882036728~1400048246',
	admobInterstitialAdId_iOS: 'ca-app-pub-2191584882036728/2872325289',
	admobRewardedAdId_iOS: 'ca-app-pub-2191584882036728/2570455847',
	admobAppOpenAdId_iOS: 'ca-app-pub-2191584882036728/1161171259',
	facebookAdId_interstital: '1150157359290701_1203822253924211', 
	facebookAdId_reward: '1150157359290701_1203822567257513',
	googleH5_ad_client: 'ca-pub-2191584882036728',
	googleH5_ad_channel: '4516579441',
	offsetStartdelay: 180,  //start with 1 min passed to get the first ad to show faster
	delayBetweenAds: 240,  //check for  240 (4 min) seconds passed was 180
	delayBetweenRewardedAds: 300,  //check for  600 seconds passed 
	awayResetTime: 1200,  //check if over 20 min, may have not been in the app and reopened it with out restarting 

};
export default DefaultConfig;